import { RefObject, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'next-i18next';
import Icon from '@components/icons/Icon';
import styles from '@components/CustomizeIcon/CustomizeIcon.styles';
import theme from '@styles/theme';
type PropsType = {
  hoverRef: RefObject<HTMLDivElement | HTMLAnchorElement>;
  background?: string;
};
const CustomizeIcon = ({
  hoverRef,
  background = theme.rawColors.neutralWhite
}: PropsType) => {
  const [isHovered, setIsHovered] = useState(false);
  const {
    t
  } = useTranslation('common');
  const onEnter = () => {
    setIsHovered(true);
  };
  const onLeave = () => {
    setIsHovered(false);
  };
  useEffect(() => {
    const hoverElement = hoverRef.current;
    if (hoverElement) {
      hoverElement.addEventListener('mouseenter', onEnter);
      hoverElement.addEventListener('mouseleave', onLeave);
      return () => {
        hoverElement.removeEventListener('mouseenter', onEnter);
        hoverElement.removeEventListener('mouseleave', onLeave);
      };
    }
    return () => null;
  }, [hoverRef]);
  const memorizedIcon = useMemo(() => <Icon icon="Customize" size="18px" />, [hoverRef]);
  return <span sx={styles.customizeIconBox(isHovered, background)}>
      {memorizedIcon}
      <p>{t('customize')}</p>
    </span>;
};
export default CustomizeIcon;